
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Scrollchor from 'react-scrollchor'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`An welchem Wochentag besonders viele Menschen unter `}<Scrollchor to="migrain" mdxType="Scrollchor">{`Migräne`}<i className='icon  small arrow alternate down' /></Scrollchor>{` leiden und welche Therapiemethoden wirklich helfen. Was Akupunktur bei `}<Scrollchor to="tension" mdxType="Scrollchor">{`Spannungskopfschmerzen`}<i className='icon  small arrow alternate down' /></Scrollchor>{` bringt. Wieso ein `}<Scrollchor to="moh" mdxType="Scrollchor">{`MÜKS`}<i className='icon  small arrow alternate down' /></Scrollchor>{` nicht harmlos ist und wie sich ein `}<Scrollchor to="cluster" mdxType="Scrollchor">{`Cluster-Kopfschmerz`}<i className='icon  small arrow alternate down' /></Scrollchor>{` äussert: Alles, was Sie über das Hämmern im Kopf wissen müssen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;